export const GraphSetDragTypes = {
    GRAPH_SET: 'graphSet',
    FOLDER: 'graphSetFolder'
}